/* eslint-disable */

const UserPlaceHolder = () => {
  return (
    <div className="col-lg-4 col-sm-6 mb-4">
      <div className="speaker_bx bg_white text-center">
        <div className="speaker_pic rounded-circle overflow-hidden mb-3">
          <span
            className="d-block text-primary-gray placeholder placeholder-sm rounded-circle"
            style={{ width: "105px", height: "105px" }}
          ></span>
        </div>
        <div className="speaker_info">
          <h3 className="mb-3 placeholder placeholder-sm"></h3>
          <h6 className="fs-sm text-primary">
            {" "}
            <span
              className="d-block placeholder placeholder-sm"
              style={{ width: "100px", margin: " 0 auto" }}
            ></span>{" "}
            <br />{" "}
            <span
              className="d-block placeholder placeholder-sm"
              style={{ width: "70%", margin: "0 auto" }}
            ></span>
          </h6>
        </div>

        <div className="btns_group d-flex align-items-center justify-content-center gap-2 mt-4">
          <span className="btn placeholder"></span>
          <span className="btn placeholder"></span>
        </div>
      </div>
    </div>
  );
};

export default UserPlaceHolder;
